import React from 'react';
import PropTypes from 'prop-types';
import { View, TouchableWithoutFeedback } from 'react-native';

import { popupOverlayStyle } from '../../Menu.styles';
import UserPopup from './UserPopup';

const UserPopupModal = ({ visible, onRequestClose, ...restProps }) => {
    if (visible) {
        return (
            <TouchableWithoutFeedback onPress={onRequestClose}>
                <View style={popupOverlayStyle}>
                    <UserPopup {...restProps} />
                </View>
            </TouchableWithoutFeedback>
        );
    }
    return null;
};
UserPopupModal.propTypes = {
    visible: PropTypes.bool,
    onRequestClose: PropTypes.func.isRequired
};
UserPopupModal.defaultProps = {
    visible: false
};

export default UserPopupModal;
